import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getTokenAndLocation, getTokenAndKey, tryCatch } from '.';
import pkg from '../../package.json';

/* eslint-disable import/prefer-default-export */
export const UBTUtils = new (class {
  state = {
    init: null,
    whiteLists: ['wechat-control'],
  }

  init(force = false) {
    if (force || !this.state.init) {
      this.state.init = this.api()({ force, needLogin: false }).catch(() => { }).then(() => {
        UBT.bindData({
          appVersion: pkg.version,
          appName: 'AppPlatformH5',
          userGuid: () => window.$$user.guid || window.$$user.userGuid,
          cityCode: () => window.$$user.cityCode,
          cityName: () => window.$$location && window.$$location.cityName,
          adCode: () => window.$$location && window.$$location.adCode,
          longitude: () => window.$$location && window.$$location.lng,
          latitude: () => window.$$location && window.$$location.lat,
        });
      });
    }
    return this.state.init;
  }

  pageView(...args) {
    this.init().then(() => {
      UBT.pageView(...args);
    });
  }

  pageViewOut(...args) {
    this.init().then(() => UBT.pageViewOut(...args));
  }

  moduleExpose(...args) {
    this.init().then(() => UBT.moduleExpose(...args));
  }

  clickButton(...args) {
    this.init().then(() => UBT.clickButton(...args));
  }

  customEventWithPointId(...args) {
    this.init().then(() => UBT.customEventWithPointId(...args));
  }

  api() {
    const isKey = this.hasWhiteLists();

    if (isKey) {
      return getTokenAndKey;
    }
    return getTokenAndLocation;
  }

  hasWhiteLists() {
    const { hash } = window.location || {};

    return tryCatch(() => this.state.whiteLists.some((r) => hash.indexOf(r) > -1), false);
  }
})();
